import { useState } from "react";
import { ChevronDown } from "lucide-react";
import Reveal from "./Reveal";

const FAQS = [
  {
    q: "Who is Beauty & Balance by Bella?",
    a: "Beauty & Balance by Bella is a licensed esthetician studio in downtown Sacramento, California. Owner Bella offers personalized therapeutic massage and custom facials by appointment.",
  },
  {
    q: "Where is the studio located?",
    a: "The studio is in downtown Sacramento. Exact address is shared on booking. Beauty & Balance serves Sacramento and surrounding areas.",
  },
  {
    q: "What are the studio hours?",
    a: "Monday 10am–5pm, Tuesday 11am–2pm, Wednesday 11am–2pm, and Thursday 11am–2pm. Friday through Sunday are closed. All visits are by appointment.",
  },
  {
    q: "How much does a session cost?",
    a: "A 60-minute massage is $90 and a 90-minute massage is $135. Facials range from $100 for the 60-minute Signature Glow to $145 for the 90-minute Grand Ritual. Peels and dermaplaning are $110.",
  },
  {
    q: "Are in-home or mobile sessions available?",
    a: "Yes, by request. Studio bookings are confirmed through the online form; in-home and travel requests should be sent via the Contact form with your address, service, and preferred dates so Bella can follow up directly.",
  },
  {
    q: "Is Bella a licensed esthetician?",
    a: "Yes. Bella holds an active California esthetics license issued by the Board of Barbering and Cosmetology and welcomes license verification before booking.",
  },
  {
    q: "How do I book?",
    a: "Use the Book Now button anywhere on the site or call 916-243-5514. Most requests are confirmed within one business day.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 bg-[#FAF6E8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-12 gap-10 md:gap-16">
        <div className="col-span-12 lg:col-span-4">
          <Reveal className="overline mb-6">Questions, asked &amp; answered</Reveal>
          <Reveal delay={1}>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] font-light bb-ink">
              The <span className="italic text-[#C9A65A]">essentials.</span>
            </h2>
          </Reveal>
          <Reveal delay={2}>
            <p className="mt-6 bb-ink-soft text-base sm:text-lg leading-relaxed font-light max-w-md">
              Common questions from new clients booking with a Sacramento
              esthetician for the first time.
            </p>
          </Reveal>
        </div>

        <div className="col-span-12 lg:col-span-8">
          <ul className="divide-y divide-[#D9CFA0] border-t border-b border-[#D9CFA0]">
            {FAQS.map((f, i) => {
              const isOpen = open === i;
              return (
                <li key={f.q}>
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-toggle-${i}`}
                    aria-expanded={isOpen}
                    className="w-full flex items-start justify-between gap-6 py-5 text-left"
                  >
                    <h3 className="font-serif text-xl md:text-2xl bb-ink flex-1">
                      {f.q}
                    </h3>
                    <ChevronDown
                      className={`w-5 h-5 mt-1 bb-ink transition-transform duration-300 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  <div
                    className={`grid transition-[grid-template-rows] duration-500 ease-out ${
                      isOpen ? "grid-rows-[1fr] pb-6" : "grid-rows-[0fr]"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="bb-ink-soft text-base leading-relaxed font-light max-w-2xl">
                        {f.a}
                      </p>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
}

export const HOME_FAQS = FAQS;
